import React from 'react';
import _ from "lodash";

import ChartSectionBordered from "../../../../../components_v2/ChartSectionBordered/ChartSectionBordered";
import {StructureTable} from "../../../../../components_v2/StructureTable/StructureTable";
import {
  CustomerDashboardNoDataPlaceholder
} from "../../../../../../FactSheetsPage/components/NoDataPlaceholder";
import {portfolioStructurePropsAreEquals} from '../utils';
import {getPortfolioColor} from "../../../../../utils";
import useStyles from "./styles";

const TotalAssetVolumeV2 = React.memo((props) => {
  const {
    dashboardData,
    expanded,
    onExpanded,
    portfolios,
  } = props;

  const classes = useStyles();
  const assets = _.get(dashboardData, 'portfolio_structure_volume.total_assets');
  const liabilities = _.get(dashboardData, 'portfolio_structure_volume.total_liabilities');
  const hasData = !_.isEmpty(assets) || !_.isEmpty(liabilities);

  const assetsSeries = React.useMemo(() => {
    return (assets || []).map(p => ({...p, color: getPortfolioColor(portfolios, p)}))
  }, [portfolios, assets]);

  return (
    <ChartSectionBordered
      title={<b>Vermögensaufteilung</b>}
      expanded={expanded}
      onExpanded={onExpanded}
      skipContentPadding={hasData}
      content={(
        <>
          {hasData ? (
            <>
              <div className={classes.subHeader}><b>Vermögenswerte</b></div>
              <StructureTable series={assetsSeries} useSeriesColor />
              {!_.isEmpty(liabilities) && (
                <>
                  <div className={classes.subHeader}><b>Verbindlichkeiten</b></div>
                  <StructureTable series={liabilities} useSeriesColor />
                </>
              )}
            </>
          ) : (
            <CustomerDashboardNoDataPlaceholder />
          )}
        </>
      )}
    />
  )
}, portfolioStructurePropsAreEquals);

export default TotalAssetVolumeV2;
